var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReviewF = function SvgReviewF(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 15C19.1102 15 24.3333 8 24.3333 8C24.3333 8 19.1102 1 12.6667 1C6.22317 1 1 8 1 8C1 8 6.22317 15 12.6667 15Z",
    stroke: "#E5B42F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.9163C13.4402 10.9163 14.1821 10.6091 14.7291 10.0621C15.276 9.51509 15.5833 8.77322 15.5833 7.99967C15.5833 7.22613 15.276 6.48426 14.7291 5.93728C14.1821 5.3903 13.4402 5.08301 12.6667 5.08301C11.8931 5.08301 11.1513 5.3903 10.6043 5.93728C10.0573 6.48426 9.75 7.22613 9.75 7.99967C9.75 8.77322 10.0573 9.51509 10.6043 10.0621C11.1513 10.6091 11.8931 10.9163 12.6667 10.9163Z",
    stroke: "#E5B42F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReviewF);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/review_F.c7b7061537319803147e43a226936d35.svg";